<div class="main-brands">
    <div class="modal-header brands-modal-header   align-items-center modal-spacing-header">
        <div class="search-wrapper">
            <img class="search-icon" src="../../assets/images/search.svg" alt="search-icon">
            <input type="text" placeholder="Search for Brands" (keyup)="getKeyUpEnterValue($event)"
                [(ngModel)]="searchText" />
            <div (click)="onClearSearch()" class="clear-btn" *ngIf="searchText != ''" alt="">
                <img src="../../../../assets/images/close-seacrch-brands.svg">
            </div>
        </div>

        <div class="alphabet-filter">
            <span *ngFor="let brandCate of headerBrandsAlphabet" [ngClass]="{'disabled':!brandCate?.brands?.length}">
                {{brandCate?.alphabet}}</span>
        </div>


        <button type="button" class="btn-close close pull-right close-top-modal" aria-label="Close"
            (click)="bsModalRef?.hide()">
            <img src="../../../../assets/images/wos-close-brands.svg" alt="">
        </button>

    </div>




    <div class="modal-body modal-spacing">
        <div class="column">
            <ng-container *ngIf="brandsList.length">
                <div class="group" *ngFor="let brandsCat of brandsList">
                    <h4 *ngIf="!brandsCat.id">{{brandsCat?.label}}</h4>
                    <ng-container *ngIf="brandsCat.id">
                        <input class="styled-radio" type="radio" name="brand" id="radioModal-{{brandsCat.id}}"
                            value={{brandsCat.id}} [checked]="brandsCat.id == selectedBrandId"
                            [(ngModel)]="selectedBrandId" />
                        <label for="radioModal-{{brandsCat.id}}">
                            {{brandsCat?.label}}</label>
                    </ng-container>
                </div>
            </ng-container>
            <ng-container *ngIf="!brandsList.length">
                <div class="no-listing-brands" *ngIf="!brandsList.length">
                    <img src="../../../../assets/images/wos_search(1).svg" alt="">
                    <h3>No result found</h3>
                    <p>Oops, we couldn’t find what you were looking for</p>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="modal-footer">
        <button class="cancel-btn" (click)="bsModalRef?.hide()">Cancel</button>
        <button class="apply-btn" (click)="onBrandFilterApply()">Apply</button>
    </div>
</div>